export const COUNTRIES = [
  { code: "US", name: "United States", flag: "🇺🇸", language: "English" },
  { code: "GB", name: "United Kingdom", flag: "🇬🇧", language: "English" },
  { code: "CA", name: "Canada", flag: "🇨🇦", language: "English" },
  { code: "AU", name: "Australia", flag: "🇦🇺", language: "English" },
  { code: "NZ", name: "New Zealand", flag: "🇳🇿", language: "English" },
  { code: "IE", name: "Ireland", flag: "🇮🇪", language: "English" },
  { code: "JM", name: "Jamaica", flag: "🇯🇲", language: "English" },
  { code: "ES", name: "Spain", flag: "🇪🇸", language: "Spanish" },
  { code: "MX", name: "Mexico", flag: "🇲🇽", language: "Spanish" },
  { code: "AR", name: "Argentina", flag: "🇦🇷", language: "Spanish" },
  { code: "CO", name: "Colombia", flag: "🇨🇴", language: "Spanish" },
  { code: "CL", name: "Chile", flag: "🇨🇱", language: "Spanish" },
  { code: "PE", name: "Peru", flag: "🇵🇪", language: "Spanish" },
  { code: "VE", name: "Venezuela", flag: "🇻🇪", language: "Spanish" },
  { code: "EC", name: "Ecuador", flag: "🇪🇨", language: "Spanish" },
  { code: "GT", name: "Guatemala", flag: "🇬🇹", language: "Spanish" },
  { code: "CU", name: "Cuba", flag: "🇨🇺", language: "Spanish" },
  { code: "BO", name: "Bolivia", flag: "🇧🇴", language: "Spanish" },
  { code: "DO", name: "Dominican Republic", flag: "🇩🇴", language: "Spanish" },
  { code: "UY", name: "Uruguay", flag: "🇺🇾", language: "Spanish" },
  { code: "PY", name: "Paraguay", flag: "🇵🇾", language: "Spanish" },
  { code: "CR", name: "Costa Rica", flag: "🇨🇷", language: "Spanish" },
  { code: "PA", name: "Panama", flag: "🇵🇦", language: "Spanish" },
  { code: "FR", name: "France", flag: "🇫🇷", language: "French" },
  { code: "BE", name: "Belgium", flag: "🇧🇪", language: "French" },
  { code: "CH", name: "Switzerland", flag: "🇨🇭", language: "French" },
  { code: "LU", name: "Luxembourg", flag: "🇱🇺", language: "French" },
  { code: "SN", name: "Senegal", flag: "🇸🇳", language: "French" },
  { code: "CI", name: "Ivory Coast", flag: "🇨🇮", language: "French" },
  { code: "CM", name: "Cameroon", flag: "🇨🇲", language: "French" },
  { code: "DE", name: "Germany", flag: "🇩🇪", language: "German" },
  { code: "AT", name: "Austria", flag: "🇦🇹", language: "German" },
  { code: "IT", name: "Italy", flag: "🇮🇹", language: "Italian" },
  { code: "BR", name: "Brazil", flag: "🇧🇷", language: "Portuguese" },
  { code: "PT", name: "Portugal", flag: "🇵🇹", language: "Portuguese" },
  { code: "AO", name: "Angola", flag: "🇦🇴", language: "Portuguese" },
  { code: "MZ", name: "Mozambique", flag: "🇲🇿", language: "Portuguese" },
  { code: "JP", name: "Japan", flag: "🇯🇵", language: "Japanese" },
  { code: "KR", name: "South Korea", flag: "🇰🇷", language: "Korean" },
  { code: "CN", name: "China", flag: "🇨🇳", language: "Chinese" },
  { code: "TW", name: "Taiwan", flag: "🇹🇼", language: "Chinese" },
  { code: "HK", name: "Hong Kong", flag: "🇭🇰", language: "Chinese" },
  { code: "SG", name: "Singapore", flag: "🇸🇬", language: "English" },
  { code: "IN", name: "India", flag: "🇮🇳", language: "Hindi" },
  { code: "PK", name: "Pakistan", flag: "🇵🇰", language: "Urdu" },
  { code: "BD", name: "Bangladesh", flag: "🇧🇩", language: "Bengali" },
  { code: "LK", name: "Sri Lanka", flag: "🇱🇰", language: "Sinhala" },
  { code: "NP", name: "Nepal", flag: "🇳🇵", language: "Nepali" },
  { code: "RU", name: "Russia", flag: "🇷🇺", language: "Russian" },
  { code: "UA", name: "Ukraine", flag: "🇺🇦", language: "Ukrainian" },
  { code: "BY", name: "Belarus", flag: "🇧🇾", language: "Russian" },
  { code: "KZ", name: "Kazakhstan", flag: "🇰🇿", language: "Kazakh" },
  { code: "SA", name: "Saudi Arabia", flag: "🇸🇦", language: "Arabic" },
  { code: "AE", name: "United Arab Emirates", flag: "🇦🇪", language: "Arabic" },
  { code: "EG", name: "Egypt", flag: "🇪🇬", language: "Arabic" },
  { code: "MA", name: "Morocco", flag: "🇲🇦", language: "Arabic" },
  { code: "DZ", name: "Algeria", flag: "🇩🇿", language: "Arabic" },
  { code: "TN", name: "Tunisia", flag: "🇹🇳", language: "Arabic" },
  { code: "IQ", name: "Iraq", flag: "🇮🇶", language: "Arabic" },
  { code: "JO", name: "Jordan", flag: "🇯🇴", language: "Arabic" },
  { code: "LB", name: "Lebanon", flag: "🇱🇧", language: "Arabic" },
  { code: "KW", name: "Kuwait", flag: "🇰🇼", language: "Arabic" },
  { code: "QA", name: "Qatar", flag: "🇶🇦", language: "Arabic" },
  { code: "IL", name: "Israel", flag: "🇮🇱", language: "Hebrew" },
  { code: "IR", name: "Iran", flag: "🇮🇷", language: "Persian" },
  { code: "TR", name: "Turkey", flag: "🇹🇷", language: "Turkish" },
  { code: "NL", name: "Netherlands", flag: "🇳🇱", language: "Dutch" },
  { code: "SE", name: "Sweden", flag: "🇸🇪", language: "Swedish" },
  { code: "NO", name: "Norway", flag: "🇳🇴", language: "Norwegian" },
  { code: "DK", name: "Denmark", flag: "🇩🇰", language: "Danish" },
  { code: "FI", name: "Finland", flag: "🇫🇮", language: "Finnish" },
  { code: "IS", name: "Iceland", flag: "🇮🇸", language: "Icelandic" },
  { code: "PL", name: "Poland", flag: "🇵🇱", language: "Polish" },
  { code: "CZ", name: "Czech Republic", flag: "🇨🇿", language: "Czech" },
  { code: "SK", name: "Slovakia", flag: "🇸🇰", language: "Slovak" },
  { code: "HU", name: "Hungary", flag: "🇭🇺", language: "Hungarian" },
  { code: "RO", name: "Romania", flag: "🇷🇴", language: "Romanian" },
  { code: "BG", name: "Bulgaria", flag: "🇧🇬", language: "Bulgarian" },
  { code: "GR", name: "Greece", flag: "🇬🇷", language: "Greek" },
  { code: "HR", name: "Croatia", flag: "🇭🇷", language: "Croatian" },
  { code: "RS", name: "Serbia", flag: "🇷🇸", language: "Serbian" },
  { code: "SI", name: "Slovenia", flag: "🇸🇮", language: "Slovenian" },
  { code: "LT", name: "Lithuania", flag: "🇱🇹", language: "Lithuanian" },
  { code: "LV", name: "Latvia", flag: "🇱🇻", language: "Latvian" },
  { code: "EE", name: "Estonia", flag: "🇪🇪", language: "Estonian" },
  { code: "ID", name: "Indonesia", flag: "🇮🇩", language: "Indonesian" },
  { code: "MY", name: "Malaysia", flag: "🇲🇾", language: "Malay" },
  { code: "PH", name: "Philippines", flag: "🇵🇭", language: "Filipino" },
  { code: "VN", name: "Vietnam", flag: "🇻🇳", language: "Vietnamese" },
  { code: "TH", name: "Thailand", flag: "🇹🇭", language: "Thai" },
  { code: "MM", name: "Myanmar", flag: "🇲🇲", language: "Burmese" },
  { code: "KH", name: "Cambodia", flag: "🇰🇭", language: "Khmer" },
  { code: "NG", name: "Nigeria", flag: "🇳🇬", language: "English" },
  { code: "ZA", name: "South Africa", flag: "🇿🇦", language: "English" },
  { code: "KE", name: "Kenya", flag: "🇰🇪", language: "Swahili" },
  { code: "GH", name: "Ghana", flag: "🇬🇭", language: "English" },
  { code: "TZ", name: "Tanzania", flag: "🇹🇿", language: "Swahili" },
  { code: "UG", name: "Uganda", flag: "🇺🇬", language: "English" },
  { code: "ET", name: "Ethiopia", flag: "🇪🇹", language: "Amharic" },
  { code: "ZW", name: "Zimbabwe", flag: "🇿🇼", language: "English" },
  { code: "BA", name: "Bosnia and Herzegovina", flag: "🇧🇦", language: "Bosnian" },
];
